import type { ISimilarBuilding } from 'shared/types/similarBuildings';
import type { TApplicationState } from 'shared/types/redux';

export const selectSimilarBuildings = (state: TApplicationState): ISimilarBuilding[] => state.similarBuildings;
